
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11452',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11452",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.201",
  "data-fetching-client": "static-1.9444",
  "foundations-components": "static-1.7457",
  "foundations-components-legacy": "static-1.482",
  "foundations-theming": "static-1.4175",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7772",
  "hub-http-shared-msw-handlers": "static-1.9393",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11187",
  "I18n": "static-7.1561",
  "jasmine-runner": "static-1.6240",
  "marketplace-storefront-base": "static-1.11512",
  "quartz": "static-1.6682",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16408",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2630",
  "reporting-testing-lib": "static-1.8306",
  "settings-ui-lib": "static-1.12287",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6660",
  "ui-addon-i18n": "static-1.10898",
  "ui-addon-react-router-dom": "static-1.9315",
  "unified-auth": "static-1.159",
  "unified-auth-core-lib": "static-1.440",
  "usage-tracker": "static-1.7100",
  "usage-tracker-core": "static-1.6950",
  "customer-data-property-utils": "static-1.7837",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15302",
  "marketplace-ui-common": "static-1.18853",
  "property-management-iframe": "static-1.12175",
  "quartz-config": "static-1.460",
  "quartz-core": "static-1.5901",
  "quartz-routing": "static-1.112",
  "quick-fetch": "static-1.3703",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4398",
  "ts-schema": "static-1.3874",
  "ui-universal-auth": "static-1.8645",
  "UIComponents": "static-3.8134",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3195",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2959",
  "quartz-webpack": "static-1.2906",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3726",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4599",
  "foundations-theming-specialty": "static-1.1891",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9195",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5144",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1096",
  "ui-fonts": "static-1.449",
  "ui-images": "static-2.1083",
  "bend-plugin-foundations-theming": "static-1.2658",
  "foundations-theming-base": "static-1.3160",
  "stylex": "static-1.27",
  "HeadJS": "static-2.703",
  "hs-test-utils-bend-plugin": "static-1.2883",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4097",
  "ai-components-ui-library": "static-1.8257",
  "ai-rendering-library": "static-1.9196",
  "chirp-fetch": "static-1.1650",
  "connections-embed-lib": "static-1.576",
  "copilot-toolkit": "static-1.10435",
  "laboratory-lib": "static-3.6929",
  "marketplace-embed": "static-1.21387",
  "marketplace-ui-details": "static-1.8749",
  "marketplace-ui-reviews": "static-1.18809",
  "marketplace-ui-tracking": "static-1.13024",
  "sanitize-text": "static-1.7907",
  "ui-addon-video-player": "static-1.8462",
  "usage-tracker-multi": "static-1.5514",
  "usage-tracker-session-replay": "static-1.4786",
  "wootric-nps": "static-1.6748",
  "apollo-link-hub-http": "static-2.4416",
  "immer": "static-1.33",
  "immerable": "static-1.3921",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2375",
  "reporting-data": "static-1.66373",
  "cssUtils": "static-1.723",
  "flux-actions": "static-1.304",
  "HubStyle": "static-2.11495",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9979",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10139",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7090",
  "icons": "static-2.618",
  "marketplace-ui-apps-core": "static-1.17386",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4290",
  "foundations-components-test-utils": "static-1.4940",
  "quartz-i18n": "static-1.357",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3498",
  "customer-data-objects": "static-1.7411",
  "property-translator": "static-1.5180",
  "frontend-preferences-client": "static-1.7691",
  "hs-promise-utils": "static-1.5358",
  "hubspot-apollo-client": "static-1.4646",
  "integrations-error-boundary-lib": "static-1.12717",
  "integrations-tracking-lib": "static-1.5350",
  "native-integrations-shared-strings": "static-1.7555",
  "reselect": "static-2.16",
  "sanitize": "static-1.4241",
  "superstore": "static-1.4538",
  "ui-shepherd-react": "static-3.9911",
  "ai-settings-ui-library": "static-1.7338",
  "hub-http-janus": "static-1.786",
  "hubspotter-http": "static-1.4448",
  "immutable-less": "static-1.4420",
  "marketplace-ui-client-types": "static-1.16260",
  "nav-meta": "static-1.28790",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10003",
  "ui-addon-upgrades": "static-9.17599",
  "inbound-db-properties-service-client": "static-1.3646",
  "property-management-common": "static-1.4462",
  "ui-addon-iframeable": "static-1.8808",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.476",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.357",
  "quartz-head": "static-1.347",
  "quartz-test": "static-1.357",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2903",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20174",
  "ContentUtils": "static-1.67519",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2252",
  "customer-data-filters-ui": "static-1.38759",
  "customer-data-objects-ui-components": "static-1.12770",
  "customer-data-reference-ui-components": "static-1.12909",
  "embedded-academy-lib": "static-1.13383",
  "ExportDialog": "static-6.10155",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40556",
  "reporting-snowflake": "static-1.54991",
  "reporting-ui-components": "static-2.63645",
  "reporting-visualizations": "static-1.58449",
  "ui-addon-teams": "static-1.21194",
  "magpie-lib": "static-1.5361",
  "magpie-types": "static-1.4821",
  "simple-logging-lib": "static-1.2817",
  "navigation-components": "static-1.17153",
  "ai-studio-lib": "static-1.10899",
  "developer-experience-shared-components": "static-1.10232",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7751",
  "ui-tool-access": "static-1.9910",
  "usage-based-billing-components-lib": "static-1.7923",
  "usage-tracker-anonymous": "static-1.5517",
  "usage-tracker-public": "static-1.6911",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3474",
  "reference-resolvers": "static-1.7926",
  "ui-extensibility-client-types": "static-1.3716",
  "hubspot-apollo-cache": "static-1.105",
  "universal-page-editor-lib": "static-1.2763",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2088",
  "merchandise-lib": "static-1.257",
  "atom": "static-1.4837",
  "purchase-motions-components": "static-1.5436",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4274",
  "batch-promise": "static-1.1317",
  "crm-component-utils": "static-1.38397",
  "crm-properties-common-lib": "static-1.5638",
  "framework-data-schema-resolvers": "static-1.6636",
  "reference-resolvers-lite": "static-1.7856",
  "navigation-messaging": "static-1.6480",
  "hubspotter-http-shared-msw-handlers": "static-1.9391",
  "cms-field-types": "static-1.4573",
  "content-icons-ui": "static-1.2144",
  "conversations-skeleton-state": "static-1.7016",
  "crm-message-bus": "static-1.42246",
  "customer-data-filters-ui-msw-helpers": "static-1.21193",
  "customer-data-ui-utilities": "static-1.9591",
  "FormUrlGenerator": "static-2.4497",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6541",
  "multi-account-reference-resolvers": "static-1.735",
  "onboarding-tours": "static-1.16212",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12953",
  "academy-common-lib": "static-1.12843",
  "content-assistance-lib": "static-1.7398",
  "dashboard-lib": "static-1.80469",
  "file-manager-components": "static-1.22785",
  "getting-started-shared-tasks": "static-1.17782",
  "hubspot-prosemirror": "static-1.17505",
  "hubspot-prosemirror-plugins": "static-1.17497",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19416",
  "share-with-third-party-component-lib": "static-1.8457",
  "ui-addon-draggable": "static-3.4532",
  "ui-asset-management-lib": "static-1.10664",
  "ui-business-units-lib": "static-1.8789",
  "user-context": "static-1.4861",
  "growth-payments-core": "static-1.24626",
  "highcharts": "static-8.99",
  "reporting-plugins": "static-1.9938",
  "reporting-reports": "static-1.66051",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.493",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28789",
  "react-codemirror": "static-1.10393",
  "apps-service-types": "static-1.3645",
  "oauth-service-types": "static-1.4007",
  "onboarding-scopes": "static-1.6231",
  "onboarding-tours-client": "static-1.4426",
  "platform-infra-nav-components": "static-1.7463",
  "subscription-experience-data-types": "static-1.14541",
  "crm-record-cards-service-types": "static-1.3422",
  "location-customization-utils-lib": "static-1.8446",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4290",
  "nav-client-types": "static-1.2122",
  "purchase-motions-api": "static-1.5439",
  "signup-constants": "static-1.18320",
  "signup-ui-url-generator": "static-2.7830",
  "trials-service-types": "static-1.3691",
  "card-properties-lib": "static-1.43422",
  "crm-actions": "static-1.6061",
  "crm-cards-data": "static-1.1140",
  "crm-cards-sdk": "static-1.42807",
  "customer-data-properties": "static-1.50685",
  "customer-data-properties-shared-msw-handlers": "static-1.8720",
  "customer-data-tracking": "static-1.6649",
  "conditional-properties-service-client": "static-1.3594",
  "crm-pipelines-api-client-types": "static-1.3935",
  "multi-currency-client-types": "static-1.3488",
  "external-options-client-types": "static-1.3954",
  "react-dnd-compat": "static-1.4390",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5118",
  "growth-onboarding-confetti": "static-1.2837",
  "growth-onboarding-next-action-utils": "static-1.1261",
  "onboarding-tours-utils": "static-1.278",
  "ui-shepherd-tracker": "static-1.7292",
  "academy-service-client": "static-1.3448",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27851",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8153",
  "video-components-external": "static-1.10472",
  "video-data-lib": "static-1.34130",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8335",
  "payment-link-components": "static-1.22837",
  "ui-addon-emoji-picker": "static-1.9656",
  "EmailSignatureEditor": "static-1.23859",
  "viral-links-lib": "static-1.6795",
  "data-token-picker": "static-1.15989",
  "FileManagerLib": "static-1.38425",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5011",
  "getting-started-shared-tasks-store": "static-1.16900",
  "campaign-roi-lib": "static-1.8182",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.157",
  "eligibility-engine-service-types": "static-1.2972",
  "crm_data": "static-4.91103",
  "crm-links": "static-1.6021",
  "customer-data-sidebar": "static-2.45319",
  "enrichment-properties-lib": "static-1.14870",
  "crm-fe-perf": "static-1.22674",
  "calling-global-api": "static-1.63535",
  "calling-internal-common": "static-1.31059",
  "calling-lifecycle-internal": "static-1.64917",
  "calling-lifecycle-messages": "static-1.57211",
  "commerce-products-lib": "static-1.8750",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.438",
  "inbounddb-objects-service-types": "static-1.4020",
  "meetings-icalendar-utils-lib": "static-1.401",
  "object-builder-ui-client": "static-1.47852",
  "pipeline-validation-client-types": "static-1.3757",
  "property-value-citations": "static-1.1299",
  "pulse": "static-1.269",
  "smart-property-lib": "static-1.5752",
  "tiered-pricing": "static-1.779",
  "ui-addon-form-validation": "static-1.10761",
  "growth-onboarding-feedback-components": "static-1.6352",
  "content-media-composition-data-lib": "static-1.11328",
  "content-media-compositions": "static-2.15335",
  "media-bridge-lib": "static-1.18511",
  "commerce-tours-lib": "static-1.5667",
  "growth-onboarding-reliability": "static-1.4855",
  "sales-checkout-service-client": "static-1.3444",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21254",
  "sales-email-signature-service-client": "static-1.3611",
  "audio-components": "static-1.5563",
  "FileManagerCore": "static-1.38284",
  "FileManagerImages": "static-1.35936",
  "video-components": "static-1.12475",
  "crm_universal": "static-1.21606",
  "customer-data-email": "static-1.17614",
  "calling-error-reporting": "static-1.31065",
  "card-payment-highlight-lib": "static-1.36405",
  "card-subscription-highlight-lib": "static-1.38761",
  "commerce-billing-lib": "static-1.18400",
  "commerce-contract-lib": "static-1.11032",
  "customer-data-content": "static-1.26816",
  "invoices-highlight-card-lib": "static-1.53893",
  "orders-highlight-card-lib": "static-1.20788",
  "products-highlight-card-lib": "static-1.17034",
  "project-storage": "static-1.4499",
  "quotes-highlight-card-lib": "static-1.71027",
  "breeze-intelligence-kit": "static-1.5271",
  "crm-source-interpretation-lib": "static-1.5098",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9476",
  "policy-lib": "static-1.6551",
  "shared-worker-versioning": "static-1.10804",
  "calling-usage-tracker": "static-1.6305",
  "voice-sms-access-library": "static-1.141",
  "products-iframe-lib": "static-1.7221",
  "products-ui-components-shared-msw-handlers": "static-1.9775",
  "directed-graph": "static-1.704",
  "event-emitter": "static-1.714",
  "react-tinymce": "static-1.54527",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9539",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53653",
  "tinymce-plugins": "static-1.56767",
  "tinymce-themes": "static-1.55623",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4301",
  "video-embed": "static-1.34964",
  "social-insights-client-types": "static-1.21257",
  "sequences-lib": "static-1.7636",
  "ui-gdpr-components": "static-1.10113",
  "commerce-shared-components-lib": "static-1.17828",
  "commerce-subscription-lib": "static-1.36338",
  "commerce-tools-ui-lib": "static-1.9705",
  "utility-belt": "static-1.2309",
  "payments-enrollment-embed-lib": "static-1.21859",
  "products-ui-components": "static-1.39269",
  "quotes-client-types": "static-1.37115",
  "quotes-ui-lib": "static-1.79746",
  "SalesContentIndexUI": "static-3.8851",
  "accounting-integrations-ui-components": "static-1.6674",
  "invoices-ui-lib": "static-1.53909",
  "commerce-products-api": "static-1.1908",
  "SafeStorage": "static-1.4171",
  "invoices-iframe-lib": "static-1.55967",
  "quotes-modal-lib": "static-1.101703",
  "calling-orchestration-schema": "static-1.34918",
  "sales-views-client-types": "static-1.4058",
  "hub-http-contrib": "static-1.2811",
  "interframe": "static-3.4558",
  "tinymce-data": "static-1.39738",
  "ui-addon-sales-email": "static-1.4980",
  "layout-dnd-components": "static-1.11972",
  "layout-dnd-utils": "static-1.10947",
  "ui-brand-identity-lib": "static-1.13696",
  "NamespacedHubStyle": "static-2.8867",
  "outpost": "static-1.3974",
  "sequences-client-types-lib": "static-1.7493",
  "customer-data-associations": "static-1.7103",
  "framework-data-table": "static-2.11334",
  "customer-data-rte": "static-1.32363",
  "cv-backend-services": "static-1.1487",
  "growth-onboarding-empty-states": "static-1.5313",
  "InboxConnectUtils": "static-4.14133",
  "payments-post-enroll-local-storage-lib": "static-1.4879",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7078",
  "commerce-permissions": "static-1.519",
  "commerce-tax-lib": "static-1.272",
  "property-description-translator": "static-1.3626",
  "FireAlarmUi": "static-1.4298",
  "sales-templates-service-types-lib": "static-1.3963",
  "commerce-analytics-service-client": "static-1.3432",
  "totals-ui-components": "static-1.22912",
  "ContentData": "static-1.67594",
  "layout-data-lib": "static-1.9272",
  "deal-intel-decorators": "static-1.1120",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27631",
  "stripe-connect-js": "static-1.63",
  "commerce-totals-service-types": "static-1.3608",
  "advanced-menus-core": "static-1.14767",
  "advanced-menus-lib": "static-1.11749",
  "ui-memberships-settings-lib": "static-1.33334",
  "deal-intel-utils": "static-1.1124",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14766",
  "simple-menus-lib": "static-1.16283"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11452",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.201",
  "data-fetching-client": "/data-fetching-client/static-1.9444",
  "foundations-components": "/foundations-components/static-1.7457",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.482",
  "foundations-theming": "/foundations-theming/static-1.4175",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7772",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9393",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11187",
  "I18n": "/I18n/static-7.1561",
  "jasmine-runner": "/jasmine-runner/static-1.6240",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11512",
  "quartz": "/quartz/static-1.6682",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16408",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2630",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8306",
  "settings-ui-lib": "/settings-ui-lib/static-1.12287",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6660",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10898",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9315",
  "unified-auth": "/unified-auth/static-1.159",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.440",
  "usage-tracker": "/usage-tracker/static-1.7100",
  "usage-tracker-core": "/usage-tracker-core/static-1.6950",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7837",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15302",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18853",
  "property-management-iframe": "/property-management-iframe/static-1.12175",
  "quartz-config": "/quartz-config/static-1.460",
  "quartz-core": "/quartz-core/static-1.5901",
  "quartz-routing": "/quartz-routing/static-1.112",
  "quick-fetch": "/quick-fetch/static-1.3703",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4398",
  "ts-schema": "/ts-schema/static-1.3874",
  "ui-universal-auth": "/ui-universal-auth/static-1.8645",
  "UIComponents": "/UIComponents/static-3.8134",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2959",
  "quartz-webpack": "/quartz-webpack/static-1.2906",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3726",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4599",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1891",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9195",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5144",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1096",
  "ui-fonts": "/ui-fonts/static-1.449",
  "ui-images": "/ui-images/static-2.1083",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2658",
  "foundations-theming-base": "/foundations-theming-base/static-1.3160",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.703",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2883",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4097",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8257",
  "ai-rendering-library": "/ai-rendering-library/static-1.9196",
  "chirp-fetch": "/chirp-fetch/static-1.1650",
  "connections-embed-lib": "/connections-embed-lib/static-1.576",
  "copilot-toolkit": "/copilot-toolkit/static-1.10435",
  "laboratory-lib": "/laboratory-lib/static-3.6929",
  "marketplace-embed": "/marketplace-embed/static-1.21387",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8749",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18809",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13024",
  "sanitize-text": "/sanitize-text/static-1.7907",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8462",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5514",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4786",
  "wootric-nps": "/wootric-nps/static-1.6748",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4416",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3921",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2375",
  "reporting-data": "/reporting-data/static-1.66373",
  "cssUtils": "/cssUtils/static-1.723",
  "flux-actions": "/flux-actions/static-1.304",
  "HubStyle": "/HubStyle/static-2.11495",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9979",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10139",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7090",
  "icons": "/icons/static-2.618",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17386",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4290",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4940",
  "quartz-i18n": "/quartz-i18n/static-1.357",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3498",
  "customer-data-objects": "/customer-data-objects/static-1.7411",
  "property-translator": "/property-translator/static-1.5180",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7691",
  "hs-promise-utils": "/hs-promise-utils/static-1.5358",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4646",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12717",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5350",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7555",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4241",
  "superstore": "/superstore/static-1.4538",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9911",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7338",
  "hub-http-janus": "/hub-http-janus/static-1.786",
  "hubspotter-http": "/hubspotter-http/static-1.4448",
  "immutable-less": "/immutable-less/static-1.4420",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16260",
  "nav-meta": "/nav-meta/static-1.28790",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10003",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17599",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3646",
  "property-management-common": "/property-management-common/static-1.4462",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8808",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.476",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.357",
  "quartz-head": "/quartz-head/static-1.347",
  "quartz-test": "/quartz-test/static-1.357",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2903",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20174",
  "ContentUtils": "/ContentUtils/static-1.67519",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2252",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38759",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12770",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12909",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13383",
  "ExportDialog": "/ExportDialog/static-6.10155",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40556",
  "reporting-snowflake": "/reporting-snowflake/static-1.54991",
  "reporting-ui-components": "/reporting-ui-components/static-2.63645",
  "reporting-visualizations": "/reporting-visualizations/static-1.58449",
  "ui-addon-teams": "/ui-addon-teams/static-1.21194",
  "magpie-lib": "/magpie-lib/static-1.5361",
  "magpie-types": "/magpie-types/static-1.4821",
  "simple-logging-lib": "/simple-logging-lib/static-1.2817",
  "navigation-components": "/navigation-components/static-1.17153",
  "ai-studio-lib": "/ai-studio-lib/static-1.10899",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10232",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7751",
  "ui-tool-access": "/ui-tool-access/static-1.9910",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7923",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5517",
  "usage-tracker-public": "/usage-tracker-public/static-1.6911",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3474",
  "reference-resolvers": "/reference-resolvers/static-1.7926",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3716",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.105",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2763",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2088",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "atom": "/atom/static-1.4837",
  "purchase-motions-components": "/purchase-motions-components/static-1.5436",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4274",
  "batch-promise": "/batch-promise/static-1.1317",
  "crm-component-utils": "/crm-component-utils/static-1.38397",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5638",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6636",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7856",
  "navigation-messaging": "/navigation-messaging/static-1.6480",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9391",
  "cms-field-types": "/cms-field-types/static-1.4573",
  "content-icons-ui": "/content-icons-ui/static-1.2144",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7016",
  "crm-message-bus": "/crm-message-bus/static-1.42246",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21193",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9591",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4497",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6541",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.735",
  "onboarding-tours": "/onboarding-tours/static-1.16212",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12953",
  "academy-common-lib": "/academy-common-lib/static-1.12843",
  "content-assistance-lib": "/content-assistance-lib/static-1.7398",
  "dashboard-lib": "/dashboard-lib/static-1.80469",
  "file-manager-components": "/file-manager-components/static-1.22785",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17782",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17505",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17497",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19416",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8457",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4532",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10664",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8789",
  "user-context": "/user-context/static-1.4861",
  "growth-payments-core": "/growth-payments-core/static-1.24626",
  "highcharts": "/highcharts/static-8.99",
  "reporting-plugins": "/reporting-plugins/static-1.9938",
  "reporting-reports": "/reporting-reports/static-1.66051",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.493",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28789",
  "react-codemirror": "/react-codemirror/static-1.10393",
  "apps-service-types": "/apps-service-types/static-1.3645",
  "oauth-service-types": "/oauth-service-types/static-1.4007",
  "onboarding-scopes": "/onboarding-scopes/static-1.6231",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4426",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7463",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14541",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3422",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8446",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4290",
  "nav-client-types": "/nav-client-types/static-1.2122",
  "purchase-motions-api": "/purchase-motions-api/static-1.5439",
  "signup-constants": "/signup-constants/static-1.18320",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7830",
  "trials-service-types": "/trials-service-types/static-1.3691",
  "card-properties-lib": "/card-properties-lib/static-1.43422",
  "crm-actions": "/crm-actions/static-1.6061",
  "crm-cards-data": "/crm-cards-data/static-1.1140",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42807",
  "customer-data-properties": "/customer-data-properties/static-1.50685",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8720",
  "customer-data-tracking": "/customer-data-tracking/static-1.6649",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3594",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3935",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3488",
  "external-options-client-types": "/external-options-client-types/static-1.3954",
  "react-dnd-compat": "/react-dnd-compat/static-1.4390",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5118",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2837",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1261",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.278",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7292",
  "academy-service-client": "/academy-service-client/static-1.3448",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27851",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8153",
  "video-components-external": "/video-components-external/static-1.10472",
  "video-data-lib": "/video-data-lib/static-1.34130",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8335",
  "payment-link-components": "/payment-link-components/static-1.22837",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9656",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "viral-links-lib": "/viral-links-lib/static-1.6795",
  "data-token-picker": "/data-token-picker/static-1.15989",
  "FileManagerLib": "/FileManagerLib/static-1.38425",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5011",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16900",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.157",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2972",
  "crm_data": "/crm_data/static-4.91103",
  "crm-links": "/crm-links/static-1.6021",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45319",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14870",
  "crm-fe-perf": "/crm-fe-perf/static-1.22674",
  "calling-global-api": "/calling-global-api/static-1.63535",
  "calling-internal-common": "/calling-internal-common/static-1.31059",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64917",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57211",
  "commerce-products-lib": "/commerce-products-lib/static-1.8750",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.438",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4020",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.401",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47852",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3757",
  "property-value-citations": "/property-value-citations/static-1.1299",
  "pulse": "/pulse/static-1.269",
  "smart-property-lib": "/smart-property-lib/static-1.5752",
  "tiered-pricing": "/tiered-pricing/static-1.779",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10761",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6352",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11328",
  "content-media-compositions": "/content-media-compositions/static-2.15335",
  "media-bridge-lib": "/media-bridge-lib/static-1.18511",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5667",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4855",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3444",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21254",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3611",
  "audio-components": "/audio-components/static-1.5563",
  "FileManagerCore": "/FileManagerCore/static-1.38284",
  "FileManagerImages": "/FileManagerImages/static-1.35936",
  "video-components": "/video-components/static-1.12475",
  "crm_universal": "/crm_universal/static-1.21606",
  "customer-data-email": "/customer-data-email/static-1.17614",
  "calling-error-reporting": "/calling-error-reporting/static-1.31065",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36405",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38761",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18400",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11032",
  "customer-data-content": "/customer-data-content/static-1.26816",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53893",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20788",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17034",
  "project-storage": "/project-storage/static-1.4499",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71027",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5271",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5098",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9476",
  "policy-lib": "/policy-lib/static-1.6551",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10804",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6305",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.141",
  "products-iframe-lib": "/products-iframe-lib/static-1.7221",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9775",
  "directed-graph": "/directed-graph/static-1.704",
  "event-emitter": "/event-emitter/static-1.714",
  "react-tinymce": "/react-tinymce/static-1.54527",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9539",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53653",
  "tinymce-plugins": "/tinymce-plugins/static-1.56767",
  "tinymce-themes": "/tinymce-themes/static-1.55623",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4301",
  "video-embed": "/video-embed/static-1.34964",
  "social-insights-client-types": "/social-insights-client-types/static-1.21257",
  "sequences-lib": "/sequences-lib/static-1.7636",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10113",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17828",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36338",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9705",
  "utility-belt": "/utility-belt/static-1.2309",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21859",
  "products-ui-components": "/products-ui-components/static-1.39269",
  "quotes-client-types": "/quotes-client-types/static-1.37115",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79746",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8851",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6674",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53909",
  "commerce-products-api": "/commerce-products-api/static-1.1908",
  "SafeStorage": "/SafeStorage/static-1.4171",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55967",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101703",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34918",
  "sales-views-client-types": "/sales-views-client-types/static-1.4058",
  "hub-http-contrib": "/hub-http-contrib/static-1.2811",
  "interframe": "/interframe/static-3.4558",
  "tinymce-data": "/tinymce-data/static-1.39738",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4980",
  "layout-dnd-components": "/layout-dnd-components/static-1.11972",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10947",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13696",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8867",
  "outpost": "/outpost/static-1.3974",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7493",
  "customer-data-associations": "/customer-data-associations/static-1.7103",
  "framework-data-table": "/framework-data-table/static-2.11334",
  "customer-data-rte": "/customer-data-rte/static-1.32363",
  "cv-backend-services": "/cv-backend-services/static-1.1487",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5313",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14133",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4879",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7078",
  "commerce-permissions": "/commerce-permissions/static-1.519",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.272",
  "property-description-translator": "/property-description-translator/static-1.3626",
  "FireAlarmUi": "/FireAlarmUi/static-1.4298",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3963",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3432",
  "totals-ui-components": "/totals-ui-components/static-1.22912",
  "ContentData": "/ContentData/static-1.67594",
  "layout-data-lib": "/layout-data-lib/static-1.9272",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1120",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27631",
  "stripe-connect-js": "/stripe-connect-js/static-1.63",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3608",
  "advanced-menus-core": "/advanced-menus-core/static-1.14767",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11749",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33334",
  "deal-intel-utils": "/deal-intel-utils/static-1.1124",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14766",
  "simple-menus-lib": "/simple-menus-lib/static-1.16283"
}
};
